(function() {
    'use strict';
a3_cabin_reports.factory('CrewAssessmentFactory', CrewAssessmentFactory);
                                                   
    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name CrewAssessmentFactory
    * @description 
    *   Add, Update, Delete and Get Cabin Crew Feedback.
    * @ngInject
    */
function CrewAssessmentFactory(localStorageMD5Service, CrewAssessmentMemberFactory, FlightFactory, CrewAssessmentTemplateFactory, CabinReportLocalEditFactory,GenericService, CrewRouteFactory) {

        /**
        * Initialize the CrewAssessment
        * @memberof CrewAssessmentFactory
        */
		function CrewAssessment() {
			this.Id = null;
			this.UserId = null;
			this.Route = null;
			this.DutyDate = null;
			this.DutyDay = null;
			this.AcType = null;
			this.Status = 'Pending';
			this.IsExist = false;
			this.assessedBy = [];
			this.CrewAssessmentMembers = [];
			this.Flights = [];
			this.GetId = GetId;
            this.start = null;
            this.end = null;
		}
				
		var objType = 'crewAssessments';
		var objCallback = CrewAssessment;  
				
		var service = 
		{  
			getCrewAssessmentsFromStorage : getCrewAssessmentsFromStorage,
			setCrewAssessmentsToStorage : setCrewAssessmentsToStorage,
			setCrewAssessmentToStorage : setCrewAssessmentToStorage,
			getCrewAssessmentFromStorage : getCrewAssessmentFromStorage,
			getCountOfUncompletedAssessments : getCountOfUncompletedAssessments,
			getCrewAssessmentByRoute : getCrewAssessmentByRoute,
			fromObject : fromObject,
			fromObjectList : fromObjectList,
			getNewCrewAssessment : getNewCrewAssessment,
			getTempAssessment : getTempAssessment,
			saveTempAssessment : saveTempAssessment,
			clearTempAssessment : clearTempAssessment,
			updateCrewMembers : updateCrewMembers,
			updateCrewAssessment : updateCrewAssessment,
			getAssesedCabinReports : getAssesedCabinReports,
			existsForRouteDutyDate : existsForRouteDutyDate,
			getAssementsReadyToSend : getAssementsReadyToSend,
			storeFlightsWithAssessments : storeFlightsWithAssessments,
			updateFlightsAssessment : updateFlightsAssessment,
            updateAssessmentFlights : updateAssessmentFlights,
			storeCrewRoutesWithAssessments : storeCrewRoutesWithAssessments,
			updateCrewRouteAssessment : updateCrewRouteAssessment
		};
		
		//object functions
        /**
         * Overide default get Id
         * @memberof CrewAssessmentFactory
         * @returns {number} Id 
         */
		function GetId(){
			return this.Id;
		}

		//factory functions
         /**
         * Get Crew Assessments
         * @memberof CrewAssessmentFactory
         * @returns {Array} crewAssesments 
         */
		function getCrewAssessmentsFromStorage() {
            var lsItems = GenericService.list(objType,objCallback);
            var items = [];
            for (var i = 0; i < lsItems.length; i++) {
				if (lsItems[i]) {
					items.push(lsItems[i]);
				}
			}
			return items;
		}

        /**
         * Save Crew Assessments to storage
         * @memberof CrewAssessmentFactory
         * @param {Array} crewAssessments A list of Cabin Crew Feedbacks
         */
		function setCrewAssessmentsToStorage(crewAssessments) {
			GenericService.saveAll(crewAssessments,objType,objCallback);
		}

        /**
         * Save one Crew Assessment to storage
         * @memberof CrewAssessmentFactory
         * @param {Object} crewAssessment A Cabin Crew Feedback
         */
		function setCrewAssessmentToStorage(crewAssessment) {
			GenericService.save(crewAssessment,objType,objCallback);
		}

        /**
         * Get a Crew Assessment from storage
         * @memberof CrewAssessmentFactory
         * @param {number} crewAssessmentId  the Id of the selected Crew Assessment
         * @returns {Object} crewAssesment
         */
		function getCrewAssessmentFromStorage(crewAssessmentId) {
			return GenericService.get(crewAssessmentId,objType,objCallback);
		}

        /**
         * Get Count of Uncompleted Assessments 
         * @memberof CrewAssessmentFactory
         * @returns {number} count
         */
		function getCountOfUncompletedAssessments() {
			var crewAssessments = getCrewAssessmentsFromStorage();
			var count = 0;
			if (crewAssessments == null)
				return 0;

			for (var i = 0; i < crewAssessments.length; i++) {
				if (!crewAssessments[i].IsExist && crewAssessments[i].Status != "Completed") {
					count++;
				}
			}
			return count;
		};

        /**
         * Get  Crew Assessment By route and Duty Date
         * @memberof CrewAssessmentFactory
         * @param {string} Route  the Route of the desired Crew Assessment
         * @param {string} DutyDate  the Duty Date of the desired Crew Assessment
         * @returns {Object} crewAssesment
         */
		function getCrewAssessmentByRoute(Route, DutyDate) {
			var crewAssessments = getCrewAssessmentsFromStorage();
			if (crewAssessments == null)
				return null;

			var result = null;

			var arrayLength = crewAssessments.length;
			for (var i = 0; i < arrayLength; i++) {
				if (crewAssessments[i].Route == Route && crewAssessments[i].DutyDate == DutyDate) {
					result = crewAssessments[i];
					break;
				}
			}
			return result;
		}

        /**
         * Extend Object from the default CrewAssessment Object
         * @memberof CrewAssessmentFactory
         * @param {Object} obj  a crewAssesment
         * @returns {Object} crewAssesment
         */
		function fromObject (obj){
			return GenericService.fromObject(obj,objCallback);
		}

        /**
         * Extend an array of Objects from the default CrewAssessment Object
         * @memberof CrewAssessmentFactory
         * @param {Array} objList  an Array Of crewAssesments
         * @returns {Array} crewAssesments
         */
		function fromObjectList (objList){
			return GenericService.fromObjectList(objList,objCallback);
		}

        /**
         * Initialize a new Crew Assessment from the default Constructor
         * @memberof CrewAssessmentFactory
         * @returns {Object} crewAssesment
         */
		function getNewCrewAssessment() {
			return GenericService.constructor(objCallback);
		};

    
        /**
         * Get the Temporary Assessment from the local storage
         * @memberof CrewAssessmentFactory
         * @returns {Object} crewAssesment
         */
		function getTempAssessment() {
			var crewAssessmentLocalEdit = localStorageMD5Service.get('crewAssessmentLocalEdit_TEMP');
			return fromObject(crewAssessmentLocalEdit);
		};

        /**
         * Save the Temporary Assessment to  the local storage
         * @memberof CrewAssessmentFactory
         * @param {Object} assessment  a crewAssesment
         * @param {number} FlightId  a crewAssesment
         */
		function saveTempAssessment(assessment,FlightId) {
            if (assessment){
                assessment.FlightId = FlightId;
                localStorageMD5Service.remove('crewAssessmentLocalEdit_TEMP');
                localStorageMD5Service.set('crewAssessmentLocalEdit_TEMP', assessment);
            }
		};

        /**
         * Remove the Temporary Assessment of  the local storage
         * @memberof CrewAssessmentFactory
         */
		function clearTempAssessment() {
			localStorageMD5Service.remove('crewAssessmentLocalEdit_TEMP');
		};

        /**
         * Update CrewMembers of the assessment based on CCMSPositions
         * @memberof CrewAssessmentFactory
         * @param {string} CCMSPositions  the ccms Position of the Flight
         * @param {string} Route  The route of the assessment
         * @param {string} DutyDate  The duty date of the assessment
         */
		function updateCrewMembers(CCMSPositions, Route, DutyDate) {
			var assessment = getCrewAssessmentByRoute(Route, DutyDate);
			var crewAssessmentTemplate = CrewAssessmentTemplateFactory.getCrewAssessmentTemplateFromStorage();
			var routeFlights = FlightFactory.getFlightsByRoute(Route, DutyDate)
			var isChanged = false;

			if (CCMSPositions != null && assessment != null) {

				for (var i = 0; i < CCMSPositions.length; i++) {
					var isExists = false;

					for (var j = 0; j < assessment.CrewAssessmentMembers.length; j++) {
						if (CCMSPositions[i].CrewId == assessment.CrewAssessmentMembers[j].aimsId) {
							isExists = true;

							if (CCMSPositions[i].CCMS == "N/A") {
								var isValid = false;

								for (var h = 0; h < routeFlights.length; h++) {
									var localReport = CabinReportLocalEditFactory.getCabinReportLocalEditForFlight(routeFlights[h].FlightId);

									if (localReport != null) {
										for (var e = 0; e < localReport.CCMSCrewPositions.length; e++) {
											if (CCMSPositions[i].CrewId == localReport.CCMSCrewPositions[e].CrewId && localReport.CCMSCrewPositions[e].CCMS != "N/A") {
												isValid = true;
												break;
											}
										}
									}
									if (isValid) {
										break;
									}
								}
								if (assessment.CrewAssessmentMembers[j].IsValid != isValid) {
									isChanged = true;
								}
								assessment.CrewAssessmentMembers[j].IsValid = isValid;
							} else {
								if (!assessment.CrewAssessmentMembers[j].IsValid) {
									isChanged = true;
								}
								assessment.CrewAssessmentMembers[j].IsValid = true;
							}
						}
					}

					if (!isExists && CCMSPositions[i].IsManual) {
						var crewMember = CrewAssessmentMemberFactory.newMember();
						crewMember.aimsId = CCMSPositions[i].CrewId;
						crewMember.assessmentItems = crewAssessmentTemplate
						crewMember.name = CCMSPositions[i].Name;
						crewMember.position = CCMSPositions[i].Position;
						crewMember.shortname = CCMSPositions[i].Initials;
						crewMember.IsManual = true;
						crewMember.IsCompleted = false;
						crewMember.IsValid = (CCMSPositions[i].CCMS != "N/A");
						isChanged = true;
						assessment.CrewAssessmentMembers.push(crewMember);
					}
				}

				for (var i = 0; i < assessment.CrewAssessmentMembers.length; i++) {
					for (var h = 0; h < routeFlights.length; h++) {
						var localReport = CabinReportLocalEditFactory.getCabinReportLocalEditForFlight(routeFlights[h].FlightId);

						if (localReport != null) {
							isExists = false;

							for (var j = 0; j < localReport.CCMSCrewPositions.length; j++) {
								if (localReport.CCMSCrewPositions[j].CrewId == assessment.CrewAssessmentMembers[i].aimsId) {
									isExists = true;
									break;
								}
							}
						}
					}
					if (!isExists) {
						if (assessment.CrewAssessmentMembers[i].IsValid) {
							isChanged = true;
						}
						assessment.CrewAssessmentMembers[i].IsValid = false;
					}
				}
				if (isChanged && assessment.Status != "Pending") {
					assessment.Status = "Draft";
					var flights = FlightFactory.getFlightsFromStorage();

					for (var i = 0; i < flights.length; i++) {
						if (flights[i].assessment && flights[i].assessment.Id == assessment.Id) {
							flights[i].assessment.Status = assessment.Status;
						}
					}
					FlightFactory.setFlightsToStorage(flights);
				}
			 setCrewAssessmentToStorage(assessment);
			}
		}

    
        /**
         * Update Assessment from the new Assessment from Sync
         * @memberof CrewAssessmentFactory
         * @param {Object} assessment  The assessment
         * @param {Object} newAssessment  The new assessment
         */		
		function updateCrewAssessment(assessment, newAssessment) {
			var crewAssessmentTemplate = CrewAssessmentTemplateFactory.getCrewAssessmentTemplateFromStorage();
			if (crewAssessmentTemplate == null) return assessment;
		
			// Load the flight
			var flights = FlightFactory.getFlightsByRoute(assessment.Route, assessment.DutyDate);
			if (flights == null) return assessment;
		
			assessment.Flights = [];
			assessment.AcType = flights[0].AcType;
			assessment = updateAssessmentFlights(assessment, flights);
		
			var isUpdated = false;
		
			// Flags to check member states
			var validCrewCount = 0;         // Non-outdated and exists
			var outdatedCrewCount = 0;      // Outdated
			var nonExistentCrewCount = 0;   // Non-outdated but doesn't exist
		
			for (var i = 0; i < newAssessment.assessmentCrew.length; i++) {
				var isCreated = false;
		
				// Update flags based on crew member status
				if (newAssessment.assessmentCrew[i].IsOutdated && !newAssessment.assessmentCrew[i].IsExist) {
					outdatedCrewCount++;
				} else if (!newAssessment.assessmentCrew[i].IsExist) {
					nonExistentCrewCount++;
				} else {
					validCrewCount++;
				}
		
				for (var l = 0; l < assessment.CrewAssessmentMembers.length; l++) {
					if (newAssessment.assessmentCrew[i].CrewAimsId == assessment.CrewAssessmentMembers[l].aimsId ||
						newAssessment.assessmentCrew[i].CrewId == assessment.CrewAssessmentMembers[l].Id) {
		
						assessment.CrewAssessmentMembers[l].aimsId = newAssessment.assessmentCrew[i].CrewAimsId;
						assessment.CrewAssessmentMembers[l].id = newAssessment.assessmentCrew[i].CrewId;
						assessment.CrewAssessmentMembers[l].name = newAssessment.assessmentCrew[i].Name;
						assessment.CrewAssessmentMembers[l].IsValid = true;
						assessment.CrewAssessmentMembers[l].IsOutdated = newAssessment.assessmentCrew[i].IsOutdated;
						assessment.CrewAssessmentMembers[l].EndPeriod = newAssessment.assessmentCrew[i].EndPeriod;

						var newAssessmentItems = [];
		
						for (var j = 0; j < crewAssessmentTemplate.length; j++) {
							var question = {
								Id: crewAssessmentTemplate[j].Id,
								Description: crewAssessmentTemplate[j].Description,
								Label: crewAssessmentTemplate[j].Label,
								OrderNo: crewAssessmentTemplate[j].OrderNo,
								ItemValue: crewAssessmentTemplate[j].ItemValue,
								ItemDescr: null
							}
							if (assessment.CrewAssessmentMembers[l].assessmentItems) {
								for (var h = 0; h < assessment.CrewAssessmentMembers[l].assessmentItems.length; h++) {
									if (crewAssessmentTemplate[j].Id == assessment.CrewAssessmentMembers[l].assessmentItems[h].Id) {
										question.ItemValue = assessment.CrewAssessmentMembers[l].assessmentItems[h].ItemValue;
										question.ItemDescr = assessment.CrewAssessmentMembers[l].assessmentItems[h].ItemDescr;
									}
								}
							}
							newAssessmentItems.push(question);
						}
						assessment.CrewAssessmentMembers[l].assessmentItems = newAssessmentItems;
		
						if (assessment.CrewAssessmentMembers[l].IsExist != newAssessment.assessmentCrew[i].IsExist) {
							assessment.CrewAssessmentMembers[l].IsExist = newAssessment.assessmentCrew[i].IsExist;
							isUpdated = true;
						}
						isCreated = true;
						break;
					}
				}
				if (!isCreated) {
					var crewMember = CrewAssessmentMemberFactory.newMember();
					crewMember.aimsId = newAssessment.assessmentCrew[i].CrewAimsId;
					crewMember.id = newAssessment.assessmentCrew[i].CrewId;
					crewMember.assessmentItems = crewAssessmentTemplate;
					crewMember.name = newAssessment.assessmentCrew[i].Name;
					crewMember.IsCompleted = false;
					crewMember.IsValid = true;
					crewMember.IsExist = newAssessment.assessmentCrew[i].IsExist;
					crewMember.IsOutdated = newAssessment.assessmentCrew[i].IsOutdated;
					crewMember.EndPeriod = newAssessment.assessmentCrew[i].EndPeriod;
			
					assessment.CrewAssessmentMembers.push(crewMember);
					isUpdated = true;
				}
			}
		
			for (var l = 0; l < assessment.CrewAssessmentMembers.length; l++) {
				var isExists = false;
				for (var i = 0; i < newAssessment.assessmentCrew.length; i++) {
					if (newAssessment.assessmentCrew[i].CrewAimsId == assessment.CrewAssessmentMembers[l].aimsId ||
						newAssessment.assessmentCrew[i].CrewId == assessment.CrewAssessmentMembers[l].Id) {
						isExists = true;
						break;
					}
				}
				if (!isExists && !assessment.CrewAssessmentMembers[l].IsManual) {
					assessment.CrewAssessmentMembers.splice(l, 1);
					l--; // Adjust index after removal
					isUpdated = true;
				}
			}

			// Update the Status based on the flags
			if (validCrewCount > 0) {
				// If there's at least one valid (non-outdated and existing) crew member
				assessment.Status = "Stored";
			} else if (outdatedCrewCount > 0 && nonExistentCrewCount === 0) {
				// All members are outdated
				assessment.Status = "Outdated";
			} else if (nonExistentCrewCount > 0) {
				// If there are non-outdated but non-existent members
				assessment.Status = "Pending";
			} else if (isUpdated && assessment.Status == "Stored") {
				// If there were updates and it was stored before, downgrade to Draft
				assessment.Status = "Draft";
			}
		
			assessment.assessedBy = newAssessment.assessedBy;
		
			// Update IsExist based on the flag
			assessment.IsExist = validCrewCount > 0;
		
			return assessment;
		}
			
        /**
         * Get only the reports that have a stored or complete Assessment
         * @memberof CrewAssessmentFactory
         * @returns {Array} crewAssesments 
         */
		function getAssesedCabinReports() { 
			var reports = CabinReportLocalEditFactory.getCabinReportsFromStorage();
			var assessments = getCrewAssessmentsFromStorage();

			var assesedReports = [];

			for (var i = 0; i < assessments.length; i++) {
				if (assessments[i].Status != "Completed" && !assessments[i].IsExist && assessments[i].CrewAssessmentMembers.length > 0) {
					var isCompleted = true;
					var routeReports = [];
					for (var j = 0; j < reports.length; j++) {
						if (reports[j].Route == assessments[i].Route && reports[j].DutyDate == assessments[i].DutyDate) {
							if (reports[j].Status != "completed") {
								isCompleted = false;
							} else {
								routeReports.push(reports[j]);
							}
						}
					}
					if (isCompleted) {
						var flights = FlightFactory.getFlightsByRoute(assessments[i].Route, assessments[i].DutyDate);
						for (var j = 0; j < flights.length; j++) {
							if (flights[j].cabinReportStatusDescr == "Pending") {
								isCompleted = false
								break;
							}

						}
					}
					if (!isCompleted) {
						assesedReports = assesedReports.concat(routeReports);
					} else if (routeReports != []) {
						routeReports.sort(function(a, b) {
							return (new Date(b.ScheduledDeparture) - new Date(a.ScheduledDeparture))
						});
						routeReports.splice(0, 1);
						assesedReports = assesedReports.concat(routeReports);
					}

				} else {
					for (var j = 0; j < reports.length; j++) {
						if (reports[j].Route == assessments[i].Route && reports[j].DutyDate == assessments[i].DutyDate) {
							if (reports[j].Status == "completed") {
								assesedReports.push(reports[j]);
							}
						}
					}
				}
			}

			//orphaned reports
			for (var j = 0; j < reports.length; j++) {
				if (!existsForRouteDutyDate(reports[j].Route, reports[j].DutyDate)) {
					if (reports[j].Status == "completed") {
						assesedReports.push(reports[j]);
					}
				}
			}
			return assesedReports;
			}

        /**
         * Find if an assessment exists for the selected Route and Duty Date
         * @memberof CrewAssessmentFactory
         * @param {string} Route  The route of the assessment
         * @param {string} DutyDate  The duty date of the assessment
         * @returns {boolean} isExist 
         */
		function existsForRouteDutyDate(Route, DutyDate) {
			var assessments = getCrewAssessmentsFromStorage();

			var isExist = false;
			for (var j = 0; j < assessments.length; j++) {
				if (assessments[j].Route == Route && assessments[j].DutyDate == DutyDate) {
					isExist = true;
					break;
				}
			}
			return isExist;
		}

        /**
         * Update Assessment Information from flights
         * @memberof CrewAssessmentFactory
         * @param {Object} crewAssessment  The crew assessment
         * @param {Array} flights  The flights of the Assessment
         */
        function updateAssessmentFlights(crewAssessment,flights){
			for (var i = 0; i < flights.length; i++) {
                if(crewAssessment.start && crewAssessment.end){
                    var flightStart = Date.parse(flights[i].ScheduledDeparture);
                    var flightEnd = Date.parse(flights[i].ScheduledArrival);
 
                    var assesmentStart = Date.parse(crewAssessment.start);
                    if (flightStart<assesmentStart){
                         crewAssessment.start = flights[i].ScheduledDeparture;
                    }
                    else{
                        var assesmentEnd = Date.parse(crewAssessment.end);
                        if (flightEnd>assesmentEnd){
                            crewAssessment.end = flights[i].ScheduledArrival;
                        }  
                    }
                }else{
                    crewAssessment.start = flights[i].ScheduledDeparture;
                    crewAssessment.end = flights[i].ScheduledArrival;
                }
                
				var flight = {
					ScheduledDepartureDateUTC: flights[i].ScheduledDepartureDateUTC,
					FlightNo: flights[i].FlightNo,
					Departure: flights[i].Departure,
					Arrival: flights[i].Arrival,
					ScheduledDepartureTimeUTC: flights[i].ScheduledDepartureTimeUTC,
                    ScheduledDeparture: flights[i].ScheduledDeparture,
					ScheduledArrival: flights[i].ScheduledArrival,
					AcTailNo: flights[i].AcTailNo
				}
				crewAssessment.Flights.push(flight);
			}
            
            return crewAssessment;
        }
    
        /**
         * Returns the a list of cabin Crew Feedbacks that are ready to send (the reports of the assessment are completed or synched)
         * @memberof CrewAssessmentFactory
         * @param {string} Route  The route of the assessment
         * @param {string} DutyDate  The duty date of the assessment
         * @returns {Array} assessmentsToSend  
         */
		function getAssementsReadyToSend() {
			var assessments = getCrewAssessmentsFromStorage();
			var assessmentsToSend = [];
			for (var i = 0; i < assessments.length; i++) {
				if (assessments[i].Status == "Completed") {

					assessmentsToSend.push(assessments[i]);
					
					////Send assessments anyway...
					// var isCompleted = true;
					// var flights = FlightFactory.getFlightsByRoute(assessments[i].Route, assessments[i].DutyDate);
					// for (var j = 0; j < flights.length; j++) {
					// 	if (flights[j].LineStatus == "pending" || flights[j].LineStatus == "pendingoverdue" || flights[j].LineStatus == "draft") {
					// 		isCompleted = false;
					// 		break;
					// 	}
					// }
					// if (isCompleted) {
					// 	assessmentsToSend.push(assessments[i])
					// }
				}

			}
			return assessmentsToSend;
		}

        /**
         * Store Assessment inside the flights
         * @memberof CrewAssessmentFactory
         */
		function storeFlightsWithAssessments() {
			var flights = FlightFactory.getFlightsFromStorage();
			var crewAssessments = getCrewAssessmentsFromStorage();
			for (var i = 0; i < flights.length; i++) {
				for (var j = 0; j < crewAssessments.length; j++) {
					if (flights[i].Route == crewAssessments[j].Route && flights[i].DutyDate == crewAssessments[j].DutyDate) {
						flights[i].assessment = {
							Id: crewAssessments[j].Id,
							Status: crewAssessments[j].Status,
							IsExist: crewAssessments[j].IsExist,
							IsAssessedBy: crewAssessments[j].assessedBy.length > 0,
							IsCrewLess: crewAssessments[j].CrewAssessmentMembers.length < 1
						}
						break;
					}
				}
			}
			FlightFactory.setFlightsToStorage(flights);
		}

        /**
         * Update Assessments which are stored inside the flights 
         * @memberof CrewAssessmentFactory
         * @param {Object} crewAssessment  The crew assessment\
         */
		function updateFlightsAssessment(assessment) {
			var flights = FlightFactory.getFlightsFromStorage();
			for (var i = 0; i < flights.length; i++) {
				if (flights[i].assessment && flights[i].assessment.Id == assessment.Id) {
					flights[i].assessment.Status = assessment.Status;
				}
			}
			FlightFactory.setFlightsToStorage(flights);
		}

        /**
         * Store Assessment inside the crewRoutes
         * @memberof CrewAssessmentFactory
         */
		function storeCrewRoutesWithAssessments() {
			var crewRoutes = CrewRouteFactory.getCrewRoutesFromStorage();
			var crewAssessments = getCrewAssessmentsFromStorage();
			for (var i = 0; i < crewRoutes.length; i++) {
				for (var j = 0; j < crewAssessments.length; j++) {
					if (crewRoutes[i].Route == crewAssessments[j].Route && crewRoutes[i].DutyDay == crewAssessments[j].DutyDay) {
						crewRoutes[i].AssessmentInfo = {
							Id: crewAssessments[j].Id,
							Status: crewAssessments[j].Status,
							IsExist: crewAssessments[j].IsExist,
							// IsAssessedBy: crewAssessments[j].assessedBy.length > 0,
							// IsCrewLess: crewAssessments[j].CrewAssessmentMembers.length < 1,
						}
						break;
					}
				}
			}
			CrewRouteFactory.setCrewRoutesToStorage(crewRoutes);
		}

        /**
         * Update Assessments which are stored inside the crewRoute 
         * @memberof CrewAssessmentFactory
         * @param {Object} crewAssessment  The crew assessment\
         */
		function updateCrewRouteAssessment(assessment) {
			var crewRoutes = CrewRouteFactory.getCrewRoutesFromStorage();
			for (var i = 0; i < crewRoutes.length; i++) {
				if (crewRoutes[i].AssessmentInfo && crewRoutes[i].AssessmentInfo.Id == assessment.Id) {
					crewRoutes[i].AssessmentInfo.Status = assessment.Status;
				}
			}
			CrewRouteFactory.setCrewRoutesToStorage(crewRoutes);
		}
	return service;
	}
    
})();